var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMatchs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 15,
    viewBox: "0 0 31 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1538 14H7.69231C5.9174 14 4.21518 13.3152 2.96013 12.0962C1.70508 10.8772 1 9.22391 1 7.5C1 5.77609 1.70508 4.12279 2.96013 2.90381C4.21518 1.68482 5.9174 1 7.69231 1H12.1538M18.8462 1H23.3077C25.0826 1 26.7848 1.68482 28.0399 2.90381C29.2949 4.12279 30 5.77609 30 7.5C30 9.22391 29.2949 10.8772 28.0399 12.0962C26.7848 13.3152 25.0826 14 23.3077 14H18.8462M9.03704 7.5H22.1024",
    stroke: "#63A1F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatchs);
export default __webpack_public_path__ + "static/media/icon-matchs.413fc520048b98b966c4dc67616690e6.svg";
export { ForwardRef as ReactComponent };